var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 16,
    viewBox: "0 0 59 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7589 13.9116H22.7257L22.4826 13.6686L24.0384 7.25086L24.3301 6.98345H31.9389L32.5953 4.11493H27.5389L27.15 5.45196L26.9069 5.69505H25.0594L24.8649 5.45196L25.6185 2.26741L25.8859 2H35.2694L35.4638 2.26741L33.1302 11.9669H35.2207L35.391 12.2343L35.0506 13.6686L34.7589 13.9116ZM31.4528 8.92822H25.8859L25.1566 11.9669H30.7235L31.4528 8.92822Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8091 13.9116H34.6102L34.4157 13.6686L34.7561 12.2343L35.0721 11.9669H36.9925L38.8887 3.94476H36.9682L36.7738 3.70167L37.1626 2.19448L37.4543 2H47.7131L47.9318 2.19448L46.6191 7.78567L46.3274 8.02877H44.5041L44.3097 7.78567L45.2091 3.94476H41.3439L39.4477 11.9669H41.2224L41.4655 12.2343L41.1251 13.6686L40.8091 13.9116Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.492 13.9116H46.06L45.8168 13.6686L48.5152 2.26741L48.7826 2H58.4335L58.6037 2.26741L57.0478 8.80666L56.7076 9.04976H49.2932L48.6125 11.9669H53.9849L54.3009 10.5326L54.5196 10.2409H56.3186L56.4887 10.5326L55.7109 13.6686L55.492 13.9116ZM55.881 3.94476H50.5086L49.755 7.1293H55.103L55.881 3.94476Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1578 2.25269L13.8294 3.6565L14.173 3.88111H23.8378L24.3963 3.70255L24.7399 2.25269L24.3963 2H14.8603L14.1578 2.25269Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5917 14.04H15.4257L15.207 13.7969L16.7543 7.88291L17.0031 6.79332L18.14 2.2431L18.4803 2.00001H20.4251L20.6195 2.2431L19.6958 5.93815L19.234 7.88291L18.0998 12.0952L17.9679 12.5342L17.6857 13.5689L17.5917 14.04Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4205 2.28295L12.7132 5.32911L12.4303 5.61196H10.4784L10.2238 5.32911L10.4784 4.26316H4.70742L4.20442 7.03484H12.0047L12.231 7.37439L11.0145 13.7571L10.7033 14.04H0.264569L0.038208 13.7571L0.74553 10.7108L1.02837 10.428H2.98034L3.23494 10.7108L2.98034 11.7768H8.75142L9.25429 9.00511H1.45409L1.22774 8.66556L2.44426 2.28295L2.75545 2H13.1942L13.4205 2.28295Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStare);
export default __webpack_public_path__ + "static/media/STARE.3f67ca09aa012ce2fb1a785094e6f66b.svg";
export { ForwardRef as ReactComponent };